import { useMutation, useQueryClient } from '@tanstack/react-query';
import { unsubscribeMLS } from '../../../api/mls';

interface DeleteMLSParams {
  organizationId: string;
  boardCode: string;
}

/**
 * Custom hook to delete an MLS subscription from a tenant
 * @returns Mutation function and state for deleting an MLS subscription
 */
export const useDeleteMLS = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ organizationId, boardCode }: DeleteMLSParams) => {
      if (!organizationId) throw new Error('Organization ID is required');
      if (!boardCode) throw new Error('Board code is required');

      // Source swapped Firestore subscribedMLS -> Spanner via the mls service.
      await unsubscribeMLS(organizationId, boardCode);

      return { success: true, boardCode };
    },
    onSuccess: (_, { organizationId }) => {
      queryClient.invalidateQueries({ queryKey: ['tenant', organizationId] });
    },
  });
};
